import { useDashboardAddOnUrl } from "@/utils/redirects";
import { Link, Typography } from "@mui/material";
import type { JSX } from "react";

/** @returns A short message with a link to the Add On Gallery */
export function PointCloudAddOnRequiredMessage(): JSX.Element {
  const addOnUrl = useDashboardAddOnUrl();

  return (
    <Typography>
      <Link href={addOnUrl}>Point cloud management add-on</Link> required
    </Typography>
  );
}
